<template> 
  <v-dialog    
    v-model="dialog"
    :persistent="persistent"
    :scrollable="scrollable"
    :disabled="disabled"
    :width="width"  
    :max-width="maxWidth"
    :loading="loading"
  >
    <template v-slot:activator="{}">
      <slot name="buttonInside" />
    </template>
    <slot />
  </v-dialog>
</template>

<script>
export default { 
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String,Number],
      default: "auto",
    },
    maxWidth: {
      type: [String,Number],
      default: null,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    }, 
    loading: {
      type: Boolean,
      default: false,
    }, 
  }, 
  data () {
    return {
      dialog : false
    }
  },
  watch: {
    value () {    
      this.dialog = this.value
    },

    dialog () {
      if(this.dialog !== this.value) {
        this.$emit('input',this.dialog)  
      } 
    }
  },
}
</script> 
